var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"animation-container"},[_c('LottieAnimation',{attrs:{"animationData":_vm.success_animation,"loop":false,"autoPlay":true,"speed":1},on:{"complete":_vm.onComplete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }